<template>
  <b-card>
    <!-- <div class="text-center mb-2">
    <b-button @click="showMsgBoxTwo" hide-footer variant="primary">Send Mail</b-button>
    
  </div> -->
    <!-- Return value:{{String(boxTwo)}} -->
    <div class="mt-3">
      <b-pagination
        v-model="currentPage"
        pills:total-rows="rows"
        class="pagination-center"
        size="lg"
      ></b-pagination>
    </div>
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      boxTwo: "",
      rows: 100,
      currentPage: 1,
    };
  },
  methods: {
    showMsgBoxTwo() {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxOk("Data was submitted successfully", {
          class: "modal-title",
          title: "Email Sent Successfully",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          headerClass: "p-2 border-bottom-0 title-padding",
          bodyClass: "text-center",
          footerClass: "p-3 border-top-0",

          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
        })
        .catch((err) => {
          //an error occurred
        });
    },
  },
};
</script>

<style>
.modal-header {
  /* padding: 26px 20px 30px 10px; */
  font-weight: 800;
}
.page-link:hover {
  background-color: #4f0a4b;
  color: white;
}
.text-center {
  text-align: center;
}
.title-padding {
  padding: 26px 20px 30px 10px;
}
.pagination-center {
  display: flex;
  justify-content: flex-end;
}
.modal-title {
  display: flex;
  margin-left: auto;
  margin-right: auto;
}
.btn-success:hover {
  color: #fff;
  background-color: #4f0a4b !important;
  border-color: #4f0a4b !important;
}
.btn-success {
  color: #fff;
  background-color: #4f0a4b;
  border-color: #4f0a4b;
}
</style>
